// How long to wait before each try to reconnect a dropped stream; once they
// are spent the user is told the connection was lost.
export const RECONNECT_BACKOFF_MS: readonly number[] = [500, 1500, 4000];

// A stream that opens and drops at once, every time, would otherwise retry
// for as long as the turn lasts.
export const MAX_RECONNECTS_PER_TURN = 12;

// Counts drops in a row, not over a turn: a reconnect that opens a stream
// starts the count over, so a long turn outlives every drop it recovers from,
// up to a ceiling per turn.
export class ReconnectBudget {
  private attempts = 0;
  private turnAttempts = 0;

  constructor(
    private readonly backoffMs: readonly number[] = RECONNECT_BACKOFF_MS,
    private readonly maxPerTurn: number = MAX_RECONNECTS_PER_TURN
  ) {}

  next(): number | null {
    const delay = this.backoffMs[this.attempts];
    if (delay === undefined || this.turnAttempts >= this.maxPerTurn) {
      this.reset();
      return null;
    }
    this.attempts += 1;
    this.turnAttempts += 1;
    return delay;
  }

  // The stream opened again: the next drop starts a fresh run of tries.
  recovered(): void {
    this.attempts = 0;
  }

  // The turn ended, or the user asked to reconnect.
  reset(): void {
    this.attempts = 0;
    this.turnAttempts = 0;
  }
}
